export default __webpack_public_path__ + "static/media/number-chart.88661ea5.svg";